<template>
  <div>
    <div
      v-if="loader"
      class="fixed inset-0 flex items-center justify-center bg-white z-50"
    >
      <img
        src="@/assets/imgs/tuin_loader_v2.gif"
        alt="cargando..."
        class=" w-[500px]"
      >
    </div>

    <ToastAlert
      :is-active="toastAlert"
      :type="typeMsg"
      :message="msg"
      @close="closeToast"
    />
    <div 
      v-if="!loader"
      class="flex max-w-[1440px] mx-auto h-full font-poppins bg-white"
    >
      <!--Left panel-->
      <div
        v-if="page_view == 'login'"
        class="w-full sm:w-1/2 flex flex-col bg-white min-h-screen"  
      >
        <!--Asesores logo-->
        <HeaderComponent class="xl:mb-[110px] md:mb-8 mb-10"/>
        <!--New Login card-->
        <div 
          class="mx-auto px-5 md:p-0 md:ml-[80px] w-full max-w-sm bg-white border-gray-200 ">
          <form class="space-y-6" @submit.prevent="auth">
            <!--Inicio de Sesion label-->
            <h5 class="md:text-32 text-lg font-medium text-gray-900">
              Inicio de sesión
            </h5>
            <!--Email input-->
            <div>
              <label for="email" class="block mb-2 text-sm font-medium text-custom_gray">Correo</label>
              <input 
                v-model="email" 
                type="text" 
                name="email" 
                id="email" 
                :class="{
                    'bg-white border border-gray-300 text-custom_gray text-sm rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': !inputErrors.email,
                    'border border-red-500 bg-red-50 text-custom_gray text-sm rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5': inputErrors.email
                }" 
                placeholder="Ingresa tu correo"
              />
              <span v-if="inputErrors.email" class="text-red-500 text-sm font-medium focus:ring-red-500 mt-1 block">{{ inputErrors.email }}</span>
            </div>
            <!--Password input-->
            <div>
              <PasswordInputComponent
                v-model="password"
                id="password"
                name="password"
                label="Contraseña"
                placeholder="Ingresa tu contraseña"
                :error="inputErrors.password"
                
              />
              <span v-if="inputErrors.password" class="text-red-500 text-sm font-medium  mt-1 block">{{ inputErrors.password }}</span>
            </div>

            <div class="flex items-center justify-center">
              <!--Recordar contraseña check box-->
              <div class="hidden items-center">
                <div class="flex items-center h-5">
                  <input v-model="remember" id="remember" type="checkbox" value="" class="w-4 h-4 border border-gray-300 rounded bg-gray-50 text-tuin_base-0 focus:ring-transparent"/>
                </div>
                <label for="remember" class="ms-2 lg:text-xs/6 text-[12px] font-medium text-custom_gray dark:text-gray-300">Recordar Contraseña</label>
              </div>
              <!--Olvidaste contrasena link-->
              <RouterLink
                to="/forgot-password"
                class="text-[12px] lg:text-xs/6 text-tuin_base-0 hover:underline"
              >
                ¿Olvidaste tu contraseña?
              </RouterLink>
            </div>
            <!--Login button-->
            <button 
              type="submit"
              class="w-full text-white bg-tuin_base-0 hover:bg-tuin_hover focus:outline-none focus:ring-transparent not-italic font-semibold rounded-lg text-base/[18px] px-5 py-2.5 text-center"
            >
              Iniciar Sesión
            </button>
            <!--OAuth Login-->
            <div class="flex flex-col items-center text-center text-custom_black mt-9">
              <span class="text-base font-normal">Inicia sesión o crea tu cuenta</span>
              <button
                type="button"
                class="mt-6 flex items-center justify-center w-full h-11 px-3 border border-gray-400 rounded bg-white text-sm text-gray-800 font-medium hover:shadow-md transition focus:outline-none relative disabled:cursor-not-allowed disabled:opacity-40"
                @click="socialLogin('google')"
                >
                  <div class="absolute inset-0 opacity-0 bg-neutral-800 pointer-events-none transition-opacity" />
                  <div class="flex items-center justify-center w-full">
                    <div class="w-5 h-5 mr-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 48 48"
                        class="w-full h-full"
                      >
                        <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
                        <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
                        <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
                        <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
                        <path fill="none" d="M0 0h48v48H0z" />
                      </svg>
                    </div>
                  <span>Continuar con Google</span>
                </div>
              </button>
              <div class="hidden flex-row mt-2">
                <button type="button" class="hidden items-center justify-center rounded-full focus:outline-none  focus:ring-transparent" onclick="window.open('https://www.facebook.com', '_blank')">
                  <svg xmlns="http://www.w3.org/2000/svg" width="42" height="43" viewBox="0 0 42 43" fill="none">
                    <ellipse cx="21.2287" cy="19.7313" rx="18.1376" ry="18.1376" fill="url(#paint0_linear_537_8237)"/>
                    <path d="M27.9832 26.9347L28.7889 21.8154H23.7488V18.4948C23.7488 17.094 24.4515 15.7276 26.709 15.7276H29.0019V11.3693C29.0019 11.3693 26.9219 11.0234 24.9342 11.0234C20.7815 11.0234 18.0697 13.4758 18.0697 17.9137V21.8154H13.4554V26.9347H18.0697V39.3109C18.9961 39.4527 19.9438 39.5253 20.9092 39.5253C21.8747 39.5253 22.8224 39.4527 23.7488 39.3109V26.9347H27.9832Z" fill="white"/>
                    <defs>
                      <linearGradient id="paint0_linear_537_8237" x1="21.2287" y1="1.59375" x2="21.2287" y2="37.7613" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#18ACFE"/>
                        <stop offset="1" stop-color="#0163E0"/>
                      </linearGradient>
                    </defs>
                  </svg>
                </button>
                <button type="button" class="hidden items-center justify-center rounded-full focus:outline-none focus:ring-transparent" onclick="window.open('https://www.apple.com', '_blank')">
                  <svg xmlns="http://www.w3.org/2000/svg" width="43" height="42" viewBox="0 0 43 42" fill="none">
                    <path d="M39.5521 20.7274C39.5521 30.7393 31.4356 38.865 21.4146 38.865C11.3936 38.865 3.27701 30.7393 3.27701 20.7274C3.27701 10.7064 11.3936 2.58984 21.4146 2.58984C31.4356 2.58984 39.5521 10.7064 39.5521 20.7274Z" fill="#283544"/>
                    <path d="M29.916 16.1406C29.817 16.1983 27.4609 17.4168 27.4609 20.1185C27.572 23.1996 30.4342 24.2801 30.4833 24.2801C30.4342 24.3379 30.0512 25.7521 28.9166 27.2345C28.0162 28.5115 27.0167 29.799 25.4991 29.799C24.0555 29.799 23.5373 28.9479 21.8716 28.9479C20.0828 28.9479 19.5766 29.799 18.207 29.799C16.6894 29.799 15.616 28.4425 14.6664 27.1775C13.4328 25.5219 12.3843 22.9236 12.3473 20.4289C12.3224 19.107 12.5944 17.8075 13.2848 16.7037C14.2593 15.1628 15.999 14.1168 17.8989 14.0823C19.3545 14.0365 20.6501 15.0136 21.5384 15.0136C22.3898 15.0136 23.9815 14.0823 25.7824 14.0823C26.5597 14.083 28.6325 14.3012 29.916 16.1406ZM21.4153 13.8183C21.1562 12.6111 21.8716 11.4038 22.5379 10.6337C23.3892 9.70243 24.7338 9.07031 25.8934 9.07031C25.9674 10.2776 25.4983 11.4616 24.6598 12.3239C23.9074 13.2552 22.6119 13.9563 21.4153 13.8183Z" fill="white"/>
                  </svg>
                </button>
                <button type="button" class="flex items-center justify-center rounded-full focus:outline-none focus:ring-transparent"  @click="socialLogin('google')">
                  <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
                  <path d="M38.9108 21.13C38.9108 19.6387 38.7873 18.5504 38.52 17.4219H21.1434V24.1528H31.3431C31.1375 25.8256 30.0271 28.3447 27.5593 30.0374L27.5247 30.2628L33.0189 34.434L33.3996 34.4712C36.8954 31.3071 38.9108 26.6518 38.9108 21.13Z" fill="#4285F4"/>
                  <path d="M21.1422 38.8669C26.1392 38.8669 30.3342 37.2546 33.3983 34.4735L27.5581 30.0398C25.9953 31.1079 23.8977 31.8535 21.1422 31.8535C16.248 31.8535 12.0941 28.6896 10.6133 24.3164L10.3963 24.3345L4.68335 28.6674L4.60864 28.8709C7.65209 34.7959 13.9036 38.8669 21.1422 38.8669Z" fill="#34A853"/>
                  <path d="M10.6144 24.3173C10.2237 23.1887 9.99758 21.9795 9.99758 20.7301C9.99758 19.4805 10.2237 18.2714 10.5939 17.1428L10.5835 16.9025L4.79899 12.5L4.60973 12.5882C3.35537 15.0469 2.63562 17.8079 2.63562 20.7301C2.63562 23.6522 3.35537 26.4131 4.60973 28.8717L10.6144 24.3173Z" fill="#FBBC05"/>
                  <path d="M21.1423 9.60299C24.6176 9.60299 26.9618 11.0741 28.2986 12.3035L33.5218 7.30561C30.3139 4.38345 26.1393 2.58984 21.1423 2.58984C13.9036 2.58984 7.65211 6.66069 4.60864 12.5856L10.5928 17.1402C12.0941 12.767 16.248 9.60299 21.1423 9.60299Z" fill="#EB4335"/>
                </svg>
                </button>
              </div>
            </div>
            <!--Create account link-->
            <div class="flex flex-col items-center text-center text-sm font-normal text-custom_black">
              Si no tienes una cuenta
              <RouterLink 
                to="/onboarding" 
                class="text-tuin_base-0 text-sm font-semibold not-italic hover:underline"
              >
                ¡Regístrate aquí!
              </RouterLink>
            </div>
          </form>
        </div>
        <!--Old card -->
        <div class="hidden w-3/4 max-w-md bg-dark_bg-100 p-5 rounded-sm">
          <h2 class="text-2xl font-semibold mb-6">
            Iniciar sesión
          </h2>
          <div class="mb-4">
            <fwb-input
              v-model="email"
              label="Email"
              type="email"
              required=""
              label-class="text-white"
              class="custom-label"
              placeholder="Introduce tu correo electrónico"
            />
          </div>
          <div class="mb-4">
            <fwb-input
              v-model="password"
              label="Contraseña"
              type="password"
              required=""
              label-class="text-white"
              class="custom-label"
              placeholder="Introduce tu contraseña"
            />
          </div>
          <div class="mb-4 flex items-center justify-between">
            <div>
              <!-- <fwb-input
                  v-model="remember"
                  placeholder="Test@gmail.com" 
                  label="Email"
                /> -->

              <fwb-checkbox v-model="remember">
                <fwb-a class="text-white">
                  Recordar contraseña
                </fwb-a>
              </fwb-checkbox>
            </div>
            
            <router-link
              to="/forgot-password"
              class="text-tuin-100 text-sm cursor-pointer"
            >
              ¿Olvidaste tu contraseña?
            </router-link>         
          </div>
          <button
            class="w-full py-2 bg-tuin-100 hover:bg-tuin-100 rounded-md text-white font-semibold"
            @click="auth()"
          >
            Ingresar
          </button>
          <div class="mt-4 text-center">
            <router-link
              to="/create-account"
              class="text-tuin-100 text-sm cursor-pointer"
            >
              Crear cuenta
            </router-link>
          </div>
        </div>
      </div>

      <!--Right panel-->
      <div class="hidden w-1/2 sm:flex items-center justify-center bg-white">
        <div  
        >
          <img
            src="@/assets/imgs/LoginTuin.svg"
            alt="Tuin hora de hacer magia"
            class="w-auto h-auto"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from "vue";
import { FwbInput, FwbCheckbox } from "flowbite-vue";
import axios from "axios";
import { useRouter } from "vue-router";
import PasswordInputComponent from "@/components/PasswordInputComponent.vue";
let router = useRouter();
import ToastAlert from "@/commond/ToastAlert.vue";
import HeaderComponent from "@/components/login/HeaderComponent.vue";
import { useStore } from "vuex";
let store = useStore();


let page_view = ref("login");

let email = ref("");
let password = ref("");
let inputErrors = reactive({
  email: '',
  password: ''
});
let toastAlert = ref(false);
let typeMsg = ref("");
let msg = ref("");

let loader = ref(false);
//let remember = ref("");

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

async function auth() {
  loader.value = true;
  // Limpiar errores previos
  inputErrors.email = '';
  inputErrors.password = '';
  let hasError = false;
  
  if (email.value === "") {
    inputErrors.email = "El correo es obligatorio";
    hasError = true;
  } else if (!emailRegex.test(email.value)) {
    inputErrors.email = "El formato del correo no es válido";
    hasError = true;
  }

  if (password.value == "") {
    inputErrors.password = "La contraseña es obligatoria";
    hasError = true;
  }
  
  if (hasError) {
    loader.value = false;
    return false;
  }

  
  let params = { email: email.value, password: password.value };
  // try {
    await axios.post(
      `${process.env.VUE_APP_API_BASE_URL}/login`,
      params
    ).then(function (response) {      
      store.dispatch("saveUserSession", response.data.resp);
      if (response.data.resp.step == 0) {
        loader.value = false;
        router.push({ name: "step1" });
        // router.push({ name: "info_profile" });
      }else if (response.data.resp.step == 1) {
        loader.value = false;
        router.push({ name: "step1" });
        //router.push({ name: "info_company" });
      //}else if (response.data.resp.step == 2) {
        //loader.value = false;
        //router.push({ name: "dashboard" });
        //router.push({ name: "step3" });
      }else if (response.data.resp.step == 3) {        
        // router.push({ name: "properties" });
        window.location.href = "/home";
        // loader.value = false;
        // setTimeout(()=>{ loader.value = false; }, 2000)
      }else{        
        // router.push({ name: "properties" });
        window.location.href = "/home";
        // setTimeout(()=>{ loader.value = false; }, 2000)
      }
    }).catch(function(error){

      const error_resp = error.response;
      if(error_resp && error_resp.status == 422){
        // Verificar si hay errores específicos por campo
        if (error_resp.data && error_resp.data.errors) {
          if (error_resp.data.errors.email) {
            inputErrors.email = error_resp.data.errors.email[0];
          }
          if (error_resp.data.errors.password) {
            inputErrors.password = error_resp.data.errors.password[0];
          }
        } else {
          // Si solo hay un mensaje general, mostrarlo en el campo de email
          inputErrors.email = error_resp.data.message || 'Error de validación';
          inputErrors.password = error_resp.data.message || 'Error de validación';
        }
        loader.value = false;
      }

    });
    

    
  // } catch (error) {
  //   if (error.response && error.response.status == 422) {
  //     toastAlert.value = true;
  //     typeMsg.value = "danger";
  //     msg.value = error.response.data.message;
  //     loader.value = false;
  //     setTimeout(() => {
  //       closeToast();
  //     }, 3000);
  //   }
  // }
}

async function closeToast() {
  toastAlert.value = false;
  typeMsg.value = "";
  msg.value = "";
}

function socialLogin(provider) {
  // Suponiendo que la API base está en VUE_APP_API_BASE_URL
  window.location.href = `${process.env.VUE_APP_API_BASE_URL}/auth/${provider}/redirect`;
}
</script>
  
<style scoped>
/* Si el label tiene clases predeterminadas de Flowbite/Tailwind, puedes sobrescribirlas */
::v-deep .custom-label label {
  @apply text-white;
}

/* También puedes apuntar directamente al selector completo */
::v-deep .custom-label label.block.mb-2.text-sm.font-medium {
  @apply text-white;
}

</style>